// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

const stat = objectOf({
  alias: string,
  link_id: string,
  total_clicks: number,
  url: string,
});

export const isLinkAliasCampaignEmailClickDailyStatsResult = objectOf({
  stats: arrayOf(stat),
  link_param_name: string,
});
